import { ErrorBoundary } from '@sentry/react';
import { ErrorBoundaryProps } from '@sentry/react/types/errorboundary';
import React from 'react';
import { ErrorFallbackPage } from '../ErrorFallback';

interface SentryErrorBoundaryProps extends Omit<ErrorBoundaryProps, 'fallback'> {
  fallback?: ErrorBoundaryProps['fallback'];
}

export function SentryErrorBoundary({
  children,
  fallback = (props) => <ErrorFallbackPage {...props} message={props.error.message} />,
  ...errorProps
}: SentryErrorBoundaryProps) {
  return (
    <ErrorBoundary
      fallback={fallback}
      {...errorProps}
      beforeCapture={(scope, error) => {
        if (Object.hasOwnProperty.call(error, 'payload')) {
          scope.setExtra('payload', (error as any).payload);
        }
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
